export default "__VITE_ASSET__CxOxwkxV__"